import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginRoutingModule } from '../../login/login-routing.module';
import { DataTablesModule } from 'angular-datatables';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ViewReportComponent } from './view-report/view-report.component';
import { UploadAnnexureComponent } from './upload-annexure/upload-annexure.component'


@NgModule({
  declarations: [
    ViewReportComponent,
    UploadAnnexureComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    DataTablesModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    BsDatepickerModule,
  ]
})
export class PNoteModule { }
